import * as Accordion from '@radix-ui/react-accordion';
import { motion } from 'framer-motion';
import styled from 'styled-components';
import InlineSVG from 'svg-inline-react';

import SolidTriangle from 'public/solid_triangle.svg';
import { Typography } from 'src/app/components/Elements/Typography';

export const PatientName = styled(Typography).attrs({ variant: 'h3', color: 'capsuleGreen60' })``;

export const PatientAccordionTriangle = styled(props => <InlineSVG {...props} />).attrs({
  src: SolidTriangle,
})<{ isExpanded: boolean }>`
  height: 2rem;
  width: 2rem;
  color: ${props => props.theme.colors.capsuleGreen60};
  margin-right: ${props => props.theme.space.s1};
  transition: transform 0.3s linear;
  transform: ${({ isExpanded }) => (isExpanded ? `rotate(0deg)` : `rotate(-90deg)`)};

  & svg {
    height: 2rem;
    width: 2rem;
  }
`;

export const PatientAccordionRoot = Accordion.Root;
export const PatientAccordionItem = Accordion.Item;
export const PatientAccordionHeader = Accordion.Header;
export const PatientAccordionTrigger = Accordion.Trigger;
export const PatientAccordionItemContent = motion(Accordion.Content);

/**
 * Unable to extend component styles in a way that forwards the ref properly. Some components require this connection to
 * function properly. So, I can't instances of `styled(SomePrimitiveThatNeedsRef)` nor `styled(motion.div)` nor any
 * combination of the two.
 *
 * @see https://capsulerx.slack.com/archives/GARFZ69J7/p1631825244156900
 */
export const AnnoyingHackToUseCSS = styled.div`
  & h3 {
    padding: 0;
  }

  & h3 > button {
    display: flex;
    align-items: center;
    border: none;
    appearance: none;
    background-color: inherit;
    margin-top: ${props => props.theme.space.s6};
    padding-bottom: ${props => props.theme.space.s6};
    width: 100%;
  }

  & h3 > button[data-state='open'] {
    border-bottom: 1px solid ${props => props.theme.colors.transparent};
  }

  & h3 > button[data-state='closed'] {
    border-bottom: ${props => `1px solid ${props.theme.colors.capsuleGray10}`};
    transition: border-bottom 0.1s ease-in-out 0.2s;
  }

  & h3 > button:hover {
    cursor: pointer;
  }
`;
